<div
  class="flex items-center justify-between px-6 py-4 space-x-4 border rounded"
  [ngClass]="statusConfigs.cssClasses()"
>
  <div class="flex flex-col flex-1 space-y-1">
    <h3
      class="text-base font-bold text-project-2000"
      data-testid="status-card-title"
    >
      Status: {{ statusConfigs.title() }}
    </h3>
    <div class="flex space-x-3 text-sm italic text-inherit brightness-75">
      <span *ngIf="content?.publishedOn" data-testid="published-date"
        >Publish Date:
        {{ content.publishedOn | date : "dd/MM/yyyy - HH:mm" }}</span
      >
      <span *ngIf="content?.lastUpdatedOn" data-testid="last-updated-on-date"
        >Last Modified:
        {{ content.lastUpdatedOn | date : "dd/MM/yyyy - HH:mm" }}</span
      >
      <span *ngIf="content?.lastUpdatedBy">
        by {{ content.lastUpdatedBy }}</span
      >
    </div>
  </div>
  <button
    class="basis-1/4"
    mat-button
    color="primary"
    type="submit"
    (click)="handleSave.emit($event)"
    *ngIf="isEditing"
    [disabled]="!isBioPopulated"
    mat-raised-button
    data-testid="profileSubmitBtn"
  >
    <span *ngIf="!isSaving; else saving"> Save </span>
    <ng-template #saving>
      <span>Saving...</span>
    </ng-template>
  </button>
</div>
